import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Auth, Options, Request } from './plugins/msal/msalTypes'
import { msalPlugin } from './plugins/msal/msalPlugin'
import App from './App.vue'
import router from './router/router'
import OpenLayersMap from 'vue3-openlayers'
import '@nkt/common_webapplication_theme/src/js/theme.js'
import '@nkt/common_webapplication_theme/src/scss/libs.scss'
import 'vue3-openlayers/styles.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'

import { clientsPlugin } from './plugins/clients/clientsPlugin'

import '@/styles/ms-font-styles.scss'
import '@/styles/ms-general-styles.scss'

import { ConfigurationClient } from './server/MakeSenseApp-backend'

const configurationClient = new ConfigurationClient()
configurationClient.getAuthConfig().then((config) => {
  const auth: Auth = {
    clientId: config.appId!,
    authority: config.authority,
    redirectUri: window.location.origin,
    requireAuthOnInitialize: true,
    tenantId: config.tenantId,
    tenantName: config.tenantName
  }

  const request: Request = {
    scopes: [`api://${config.appId}/user_impersonation`]
  }

  const option: Options = {
    auth: auth,
    request: request,
    disabled: config.ignoreAuth
  }

  createApp(App)
    .use(router)
    .use(createPinia())
    .use(msalPlugin, option)
    .use(clientsPlugin)
    .use(OpenLayersMap)
    .mount('#app')
})
